import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from "./AuthorizationConfig";

// Create the MSAL application object
const msalInstance = new PublicClientApplication(msalConfig);

// This should be called at least once before any other MSAL method
// Export a promise to track when initialization is complete
export const msalInit = msalInstance.initialize()
  .then(() => {
    // Handle login success events
    msalInstance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        console.log("Login success");
        const result = event.payload as AuthenticationResult;
        if (result && result.account) {
          msalInstance.setActiveAccount(result.account);
        }
      } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
        console.log("Logout success");
      } else if (event.eventType === EventType.LOGIN_FAILURE) {
        console.error("Login failure:", event.error);
      }
    });

    // Handle the redirect flow once immediately at startup
    return msalInstance.handleRedirectPromise()
      .then((response) => {
        if (response) {
          msalInstance.setActiveAccount(response.account);
        }
        return msalInstance;
      })
      .catch((error) => {
        console.error("Error during redirect handling:", error);
        return msalInstance;
      });
  })
  .catch(error => {
    console.error("Error initializing MSAL:", error);
    return msalInstance;
  });

// Export default msalInstance for components to use
export default msalInstance;

// LOGIN 
// export const login = async () => {
//   await msalInstance.loginRedirect({
//     scopes: loginRequest.scopes,
//     prompt: "select_account",
//   });
// }

// LOGOUT
export const logout = async () => {
  localStorage.removeItem('userRoles');
  await msalInstance.logoutRedirect();
}